import React, { Component } from 'react';
import languageService from '../../services/language';
import './index.css';

export default class Menu extends Component {
  renderContent(menuItems) {
    const renderedMenuItems = menuItems
    .map((item, index) => {
      let icon = <i className={`fa fa-${item.icon}`}></i>;

      if (item && item.icon === 'plane') {
        icon = <img src="/assets/images/icon_departures.png" />;
      }

      return (
        <div className="comp-menu__itemcontainer col-md-2" key={`menuitem-${item.text[languageService.language]}-${index}`}>
          <a href={`${item.href}`}>
	          <div className="comp-menu__item item-with-box-shadow">
              <div>
                {icon}

                <h6>{item.text[languageService.language]}</h6>
              </div>
	          </div>
          </a>
        </div>
      );
    });

    return (
      <div className="comp-menu row">
        {renderedMenuItems}
      </div>
    );
  }

  render() {
    const rendered = !this.props.menuItems ? null : this.renderContent(this.props.menuItems);

    return rendered;
  }
}



// WEBPACK FOOTER //
// ./src/components/menu/index.js